import {Component, Input} from '@angular/core';
import {MpAllergenXBVO, MpDesignationXBVO} from "../../model/xbvo.model";
import {BaseComponent} from "../../base/base.component";

/**
 * App-Component
 */
@Component({
    selector: '<additives>',
    template: `
        <div class="EmptyBox1 GrayBack"></div>
        <div class="SoftGrayBack" style="padding: 2px 0 4px 4px;">{{v('additives')}}</div>
        <div class=" d-flex" *ngFor="let pItem of modelRows">
            <div class="">{{pItem.nr + " - " + pItem.designation}}</div>
        </div>
        <div class="EmptyBox10"></div>
    `
})
export class AdditivesComponent extends BaseComponent {

    @Input()
    modelRows: MpDesignationXBVO[];

}
